import { render } from "./navigatorPreview.vue?vue&type=template&id=2096434c&scoped=true"
import script from "./navigatorPreview.vue?vue&type=script&lang=js"
export * from "./navigatorPreview.vue?vue&type=script&lang=js"

import "./navigatorPreview.vue?vue&type=style&index=0&id=2096434c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2096434c"]])

export default __exports__